module.exports = __webpack_public_path__ + "img/LATIN10_18.73becc12.jpg";